import api from "@/api/client";

// Per-deployment brand config (non-secret), fetched ONCE at bootstrap
// (before app.mount). Each consumer falls back to its build-time VITE_* /
// hardcoded default when a field is empty, so an existing deployment with
// no app_settings row keeps working unchanged.
interface AppConfigData {
  liff_id: string;
  google_maps_key: string;
  brand_name: string;
  theme_colors: Record<string, string>;
}

const config: AppConfigData = {
  liff_id: "", google_maps_key: "", brand_name: "", theme_colors: {},
};
let loaded = false;

export async function loadAppConfig(): Promise<void> {
  if (loaded) return;
  loaded = true;
  try {
    const r = await api.get<AppConfigData>("/app-config");
    Object.assign(config, r.data);
  } catch {
    // keep empties → consumers fall back to VITE_* / hardcoded
  }
}

export function useAppConfig() {
  return {
    liffId: config.liff_id,
    googleMapsKey: config.google_maps_key,
    brandName: config.brand_name,
    themeColors: config.theme_colors,
  };
}

/** Read an injected brand-colour token, falling back to the bundled hex.
 *  Used by the spots that can't consume CSS vars (Vant `color=` props,
 *  MilestoneBar, the Google-Maps JS). */
export function themeColor(token: string, fallback: string): string {
  return config.theme_colors[token] || fallback;
}

/** Path A: override tokens.css :root defaults BEFORE mount so every
 *  `var(--color-…)` follows. Empty map → no-op → tokens.css defaults. */
export function applyThemeColors(): void {
  for (const [name, hex] of Object.entries(config.theme_colors)) {
    document.documentElement.style.setProperty(name, hex);
  }
}
